import React from 'react'
import moment from 'moment'
import { Tooltip } from 'hljd'
import Chat from '@common/Chat'
import { ctrlTextLen } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import {
  FRANCHISE_STATUS_NOT_FOLLOW,
  SOURCE_SELF,
  SOURCE_CUSTOMER,
  SOURCE_STUFF,
  SOURCE_STORE
} from '../../constant'
import { Flex } from 'hljd'
import { isExperienceStore } from '@util'

/**
 * TODO, 这个文件 css 不是 css module
 */
export default () => {
  const isExperience = isExperienceStore()

  const columns = [
    {
      title: '姓名',
      dataIndex: 'user',
      key: 'user',
      render: (user, { look_at, user_name, nick, channel_id, user_id }) => {
        user = user || {}
        return (
          <div className={`column-user ${look_at ? '' : 'dot'}`}>
            <img
              src={
                user.avatar ||
                '//qnm.hunliji.com/o_1d1g0i1o84t319ks1fch68v10k89.png'
              }
            />
            <span>{user_name || nick || user.nick}</span>
            {channel_id > 0 && (
              <Chat toUserId={user_id || ''}>
                <i
                  className="icon iconfont icon-sixin"
                  style={{ marginLeft: '6px' }}
                />
              </Chat>
            )}
          </div>
        )
      }
    },
    {
      title: '来源',
      dataIndex: 'source_name',
      key: 'source_name',
      render: (value, { source }) => {
        return (
          <Flex vc>
            <img
              src={
                source == SOURCE_SELF ||
                source == SOURCE_CUSTOMER ||
                source == SOURCE_STUFF ||
                source == SOURCE_STORE
                  ? '//qnm.hunliji.com/o_1d8qdki5kffm1fnv17o3dc81q06b.png'
                  : '//qnm.hunliji.com/o_1d8qdki5k3t61oep1sof1sp61ok0a.png'
              }
              style={{
                width: 14,
                height: 14,
                marginRight: 6,
                flexShrink: 0,
                marginTop: -2
              }}
            />
            <span>{value || '-'}</span>
          </Flex>
        )
      }
    },
    {
      title: '婚期',
      dataIndex: 'weddingday',
      key: 'weddingday',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: value => value || '-'
    },
    {
      title: '阶段',
      dataIndex: 'franchise_status',
      key: 'franchise_status',
      render: value => {
        if (value == '0' || value == '1') {
          return <span className="status-warng">沟通</span>
        } else if (value == '2') {
          return <span className="status-warng">到店</span>
        } else if (value == '3') {
          return <span className="status-success">签单</span>
        } else if (value == '4') {
          return <span className="status-success">完成服务</span>
        } else if (value == FRANCHISE_STATUS_NOT_FOLLOW) {
          return <span>不再跟进</span>
        } else {
          return <span>婚期已过</span>
        }
      }
    },
    {
      title: '添加时间',
      dataIndex: isExperience ? 'created_order_at' : 'created_at',
      key: isExperience ? 'created_order_at' : 'created_at',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (o, { created_order_at, created_at }) => {
        const at = isExperience ? created_order_at : created_at
        return <span>{at ? moment(at).format('YYYY.MM.DD HH:mm') : ''}</span>
      }
    },
    {
      title: '跟进动态',
      dataIndex: 'follow',
      key: 'follow',
      render: (o, { crm_newest_record }) => {
        crm_newest_record = crm_newest_record || {}

        const remark = dGet(crm_newest_record, 'progress.remark')
        const title = crm_newest_record.title || ''
        const content = remark || title
        const shortContent = ctrlTextLen(content, 15, '...')

        return (
          <Tooltip placement="top" title={content}>
            <span>{shortContent}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '更新时间',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (o, { crm_newest_record }) => {
        return (
          <div>
            {crm_newest_record.created_at
              ? moment(crm_newest_record.created_at).format('YYYY.MM.DD HH:mm')
              : '-'}
          </div>
        )
      }
    },
    {
      title: '负责人',
      dataIndex: 'merchant_support',
      key: 'merchant_support',
      render: (o, { merchant_support }) => {
        merchant_support = merchant_support || []
        return <span>{merchant_support.map(item => item.nick).join('、')}</span>
      }
    }
  ]

  return columns
}
